import {useLinkedAccounts, useLinkedAccountsReload} from "./LinkedAccountsContext";
import LinkedAccountsProvider from "./LinkedAccountsProvider";

export { LinkedAccountsProvider, useLinkedAccountsReload };
export default useLinkedAccounts;
